<template>
  <div>
    <div class="tent">
      <el-input
        class="searchInput"
        @keyup.enter="Search"
        v-model="val"
        placeholder="The article title, author, keywords, in this paper"
        size="small"
      ></el-input>
      <a class="search_button" @click="Search">Search</a>
      <!-- <a @click="AdvancedSearch" href="javascript:void(0);" class="highsearch">高级检索</a> -->
      <div class="clearfix"></div>
    </div>
    <div class="five quick_button">
      <span>
        <router-link to="/AdvancedSearch?isdatab=true"
          >Advanced Search</router-link
        >
      </span>
      <span>
        <router-link to="/DownloadlistViewlist?Key=ReadRank"
          >Download Ranking</router-link
        >
      </span>
      <span>
        <router-link to="/DownloadlistViewlist?Key=ViewRank"
          >Browsing Ranking</router-link
        >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'search',
  data() {
    return {
      val: '',
    }
  },
  methods: {
    //简单搜索
    Search() {
      if (this.val == '') {
        alert('Please fill out the search content')
      } else {
        this.$newOpen('/#/QuickSearch?isdatab=true')
        localStorage.setItem('value', this.val)
      }
    },
    //高级搜索
    AdvancedSearch() {
      this.$router.push('/AdvancedSearch?isdatab=true')
    },
  },
}
</script>

<style>
.searchInput .el-input__inner {
  border-radius: 0px !important;
  border: 1px #edad48 solid;
  padding: 10px;
}
.searchInput .el-input__suffix {
  line-height: 35px;
  right: -20px !important;
}
.el-input--suffix .el-input__inner {
}
.search .searchInput .el-input__inner {
  box-sizing: content-box;
  padding-right: 15px;
  margin-right: 15px;
}
.search .el-input--small {
  padding-right: 8px;
}
.searchInput .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
.searchInput {
  float: left;
  width: 75% !important;
}
.search_button {
  display: inline-block;
  float: left;
  width: 24%;
  background: #edad48;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
}
.quick_button span,
.quick_button a {
  display: block;
  font-size: 14px;
  line-height: 26px;
  text-decoration: underline;
}
@media (max-width: 1200px) {
  .quick_button span,
  .quick_button a {
    margin-right: 4%;
  }
}
.highsearch {
  line-height: 32px;
  margin-left: 10px;
}
.quick_button {
  font-size: 13px;
}
.el-input--small .el-input__wrapper{
  padding:0 !important;
}
</style>
